import styled, { css } from "styled-components";
import { Switch } from "antd";

export const SwitchStyled = styled(Switch)`
  margin-right: 6px;

  ${({ checked }) => checked && css`
    background-color: ${({ theme }) => theme.colors.primary.primary} !important;
  `}
`;
